import * as React from 'react';
import { Component } from 'react';
import Manage from './Manage';
import Internet from './Internet';
import './index.scss';

export default class TrustManager extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="trust-manage-panel">
        <Manage></Manage>
        <Internet></Internet>
      </div>
    );
  }
}
